import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ScrollContainer } from '@beef/legacy-ui-kit';
import { ScrollPaddingFix } from "./extra/ScrollPaddingFix";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

/**
 * TODO: Might consider refactoring ScrollContainerV2
 */
export var ScrollContainerV3 = function ScrollContainerV3(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isNoGrow = _ref.isNoGrow;
  return /*#__PURE__*/React.createElement(ScrollContainer, {
    className: cn('container', className),
    "data-t-id": "common-ScrollContainerV3"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('component', {
      'component--no-grow': isNoGrow
    }),
    "data-t-id": "common-ScrollContainerV3"
  }, children), /*#__PURE__*/React.createElement(ScrollPaddingFix, null));
};
ScrollContainerV3.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  isNoGrow: PropTypes.bool
} : {};